module.exports = __webpack_public_path__ + "static/media/tacometro_bajo.9e872151.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro_bajo.svg
// module id = 144
// module chunks = 0